// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* duplicate bootstrap sr-only class for users not using bootstrap/availity-uikit */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;/* 3 */
}
.loading-indicator {
    text-align: center;
}
.loading-bullet {
    display: inline-block;
    opacity: 0;
    font-size: 2em;
    color: #02a17c;
}
.block-ui {
    position: relative;
    min-height: 3em;
}
.block-ui-container {
    position: absolute;
    z-index: 1010;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    min-height: 2em;
    cursor: wait;
    overflow: hidden;
}
.block-ui-container:focus {
    outline: none;
}
.block-ui-overlay {
    width: 100%;
    height: 100%;
    opacity: 0.5;
    filter: alpha(opacity=50);
    background-color: white;
}
.block-ui-message-container {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    text-align: center;
    transform: translateY(-50%);
    z-index: 10001;
}
.block-ui-message {
    color: #333;
    background: none;
    z-index: 1011;
}

/* CSS Animations */
@keyframes fadeInRTL1 {
    0% {
        opacity: 0;
        transform: translateX(20px);
    }
    30% {
        opacity: 1;
        transform: translateX(0px);
    }
    60% {
        opacity: 1;
    }
    80% {
        opacity: 0;
    }
}
@keyframes fadeInRTL2 {
    0% {
        opacity: 0;
    }
    10% {
        opacity: 0;
        transform: translateX(20px);
    }
    40% {
        opacity: 1;
        transform: translateX(0px);
    }
    60% {
        opacity: 1;
    }
    80% {
        opacity: 0;
    }
}
@keyframes fadeInRTL3 {
    0% {
        opacity: 0;
    }
    20% {
        opacity: 0;
        transform: translateX(20px);
    }
    50% {
        opacity: 1;
        transform: translateX(0px);
    }
    60% {
        opacity: 1;
    }
    80% {
        opacity: 0;
    }
}
.loading-bullet {
    display: inline-block;
    opacity: 0;
    animation: 3s ease .5s infinite fadeInRTL1;
}
.loading-bullet + .loading-bullet {
    animation-name: fadeInRTL2;
}
.loading-bullet + .loading-bullet + .loading-bullet {
    animation-name: fadeInRTL3;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-block-ui/style.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,SAAS,CAAC,MAAM;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA,mBAAmB;AAmBnB;IACI;QACI,UAAU;QAEV,2BAA2B;IAC/B;IACA;QACI,UAAU;QAEV,0BAA0B;IAC9B;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AAsBA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;QAEV,2BAA2B;IAC/B;IACA;QACI,UAAU;QAEV,0BAA0B;IAC9B;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AAsBA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;QAEV,2BAA2B;IAC/B;IACA;QACI,UAAU;QAEV,0BAA0B;IAC9B;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,qBAAqB;IACrB,UAAU;IAEV,0CAA0C;AAC9C;AACA;IAEI,0BAA0B;AAC9B;AACA;IAEI,0BAA0B;AAC9B","sourcesContent":["/* duplicate bootstrap sr-only class for users not using bootstrap/availity-uikit */\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0,0,0,0);\n    border: 0;/* 3 */\n}\n.loading-indicator {\n    text-align: center;\n}\n.loading-bullet {\n    display: inline-block;\n    opacity: 0;\n    font-size: 2em;\n    color: #02a17c;\n}\n.block-ui {\n    position: relative;\n    min-height: 3em;\n}\n.block-ui-container {\n    position: absolute;\n    z-index: 1010;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    height: 100%;\n    min-height: 2em;\n    cursor: wait;\n    overflow: hidden;\n}\n.block-ui-container:focus {\n    outline: none;\n}\n.block-ui-overlay {\n    width: 100%;\n    height: 100%;\n    opacity: 0.5;\n    filter: alpha(opacity=50);\n    background-color: white;\n}\n.block-ui-message-container {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    text-align: center;\n    transform: translateY(-50%);\n    z-index: 10001;\n}\n.block-ui-message {\n    color: #333;\n    background: none;\n    z-index: 1011;\n}\n\n/* CSS Animations */\n@-webkit-keyframes fadeInRTL1 {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n    30% {\n        opacity: 1;\n        -webkit-transform: translateX(0px);\n        transform: translateX(0px);\n    }\n    60% {\n        opacity: 1;\n    }\n    80% {\n        opacity: 0;\n    }\n}\n@keyframes fadeInRTL1 {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n    30% {\n        opacity: 1;\n        -webkit-transform: translateX(0px);\n        transform: translateX(0px);\n    }\n    60% {\n        opacity: 1;\n    }\n    80% {\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fadeInRTL2 {\n    0% {\n        opacity: 0;\n    }\n    10% {\n        opacity: 0;\n        -webkit-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n    40% {\n        opacity: 1;\n        -webkit-transform: translateX(0px);\n        transform: translateX(0px);\n    }\n    60% {\n        opacity: 1;\n    }\n    80% {\n        opacity: 0;\n    }\n}\n@keyframes fadeInRTL2 {\n    0% {\n        opacity: 0;\n    }\n    10% {\n        opacity: 0;\n        -webkit-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n    40% {\n        opacity: 1;\n        -webkit-transform: translateX(0px);\n        transform: translateX(0px);\n    }\n    60% {\n        opacity: 1;\n    }\n    80% {\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fadeInRTL3 {\n    0% {\n        opacity: 0;\n    }\n    20% {\n        opacity: 0;\n        -webkit-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n    50% {\n        opacity: 1;\n        -webkit-transform: translateX(0px);\n        transform: translateX(0px);\n    }\n    60% {\n        opacity: 1;\n    }\n    80% {\n        opacity: 0;\n    }\n}\n@keyframes fadeInRTL3 {\n    0% {\n        opacity: 0;\n    }\n    20% {\n        opacity: 0;\n        -webkit-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n    50% {\n        opacity: 1;\n        -webkit-transform: translateX(0px);\n        transform: translateX(0px);\n    }\n    60% {\n        opacity: 1;\n    }\n    80% {\n        opacity: 0;\n    }\n}\n.loading-bullet {\n    display: inline-block;\n    opacity: 0;\n    -webkit-animation: 3s ease .5s infinite fadeInRTL1;\n    animation: 3s ease .5s infinite fadeInRTL1;\n}\n.loading-bullet + .loading-bullet {\n    -webkit-animation-name: fadeInRTL2;\n    animation-name: fadeInRTL2;\n}\n.loading-bullet + .loading-bullet + .loading-bullet {\n    -webkit-animation-name: fadeInRTL3;\n    animation-name: fadeInRTL3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
